const digest = 'dc29afdc3162a174d58fbbc46c70f461c99396e29e2242254d15ec9bb40db899';
const css = `._header_11z1b_1{font-weight:300}._listContainer_11z1b_5{gap:180px}._list_11z1b_5{list-style:disc;margin-left:16px}._list_11z1b_5 a{text-decoration:inherit}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'header': '_header_11z1b_1', 'listContainer': '_listContainer_11z1b_5', 'list': '_list_11z1b_5' };
export const header = '_header_11z1b_1';
export const listContainer = '_listContainer_11z1b_5';
export const list = '_list_11z1b_5';
export { css, digest };